module.exports = __webpack_public_path__ + "img/imgico.54473d6c.webp";